import '../../styles/index.css'
import './TabelaDetalhes.css';

function TabelaDetalhes({ arrayTabela }) {

  return (
    <table className="table table-striped table-bordered">
      <tbody>
        {
          arrayTabela.map(value => (
            <tr key={value}>
              <td className='b2'>{value[0]}</td>
              <td className='b2'>{value[1]}</td>
            </tr>
          ))
        }
      </tbody>
    </table>
  );
}

export default TabelaDetalhes;
